export default __webpack_public_path__ + "static/media/48213957a2da21504ce80d4d9b7a820d1581600181364.6bc33cf6.webp";